export default __webpack_public_path__ + "static/default-1-e5e24a6363a26cb34ac36d91b1c1a455.jpg";